// Polls a static manifest that the frontend host serves and rewrites on every
// frontend deploy (see the emit-build-version plugin in vite.config.js). This
// covers the case where the frontend ships an update without a corresponding
// backend deploy, which the API's X-App-Version header alone would miss.
// Runs on mount, on tab focus, and on a slow interval; the file is missing
// on local dev and the fetch failure is silently ignored so nothing spurious
// fires there.

import { getBundleVersion, notifyUpdateAvailable } from "./appVersion";

const MANIFEST_PATH = "/build-version.txt";
const POLL_INTERVAL_MS = 2 * 60 * 1000;

let started = false;

async function checkOnce() {
  try {
    const response = await fetch(`${MANIFEST_PATH}?t=${Date.now()}`, {
      cache: "no-store",
      credentials: "omit",
    });
    if (!response.ok) return;
    const remoteVersion = (await response.text()).trim();
    if (remoteVersion === "") return;
    if (remoteVersion !== getBundleVersion()) {
      notifyUpdateAvailable();
    }
  } catch {
    // Offline or transient network error; the next tick will try again.
  }
}

export function startAppVersionPoll() {
  if (started || typeof window === "undefined") return;
  if (getBundleVersion() === "dev") return;
  started = true;

  checkOnce();
  setInterval(checkOnce, POLL_INTERVAL_MS);
  window.addEventListener("focus", checkOnce);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkOnce();
  });
}
